import React from "react";
import { Route, Routes } from "react-router-dom";
import DashboardCompanyHeader from "../../../components/dashboardHeader/dashboardCompanyHeader"
import AddEmployee from "../../../components/dashboardTabs/addEmployee";
import Admin from "../../../components/dashboardTabs/admin";
import AppTab from "../../../components/dashboardTabs/appTab";
import EmployeeMangement from "../../../components/dashboardTabs/employeeMangement";
import Payment from "../../../components/dashboardTabs/payment";
import Report from "../../../components/dashboardTabs/report";
import Sidebar from "../../../components/sidebar/sidebar";
import Employee from "../../employee/employee";

const Company = ({ values }) => {
  return (
    <div>
      <div className=" bg-[#060409] grid overflow-y-scroll sticky top-[0] h-[100vh] grid-cols-11 z-10">
        <Sidebar image={values?.businessLogoUrl} name={values?.companyName} />
        <div className="col-span-9">
          <DashboardCompanyHeader image={values?.businessLogoUrl} />
          <div>
            <Routes>
              <Route path="/" element={<AppTab values={values} />} />
              <Route path="/admin" element={<Admin values={values} />} />
              <Route
                path="/employeemanagement"
                element={<EmployeeMangement values={values} />}
              />
              <Route
                path="/addEmployee"
                element={<AddEmployee values={values} />}
              />
              <Route path="/payments" element={<Payment values={values} />} />
              <Route path="/employee/:id" element={<Employee />} />
              <Route path="/report" element={<Report values={values} />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
